<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.book.bookList')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">
                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <!-- Filters -->
                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('filters')}}</div>
                        <div class="text-right">
                            <b-button variant="primary" size="sm" @click="detailedSearch = !detailedSearch">
                                {{$t('button.detailedSearch')}}</b-button>
                            <b-button variant="default" size="sm" @click="clearSearch()">{{$t('button.resetFilter')}}
                            </b-button>
                        </div>
                    </div>

                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label>{{$t('form.book.searchCriteria')}}</label>
                                    <v-select @input="loadPreset" label="name" :options="presetList" v-model="preset">
                                    </v-select>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.book.title')}}</label>
                                    <input type="text" v-model="search.title" @keyup="searchBooks" class="form-control">
                                </div>
                            </div>

                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.book.author')}}</label>
                                    <input type="text" class="form-control" v-model="search.author"
                                        @keyup="searchBooks">
                                </div>
                            </div>

                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.book.publisher')}}</label>
                                    <input type="text" class="form-control" v-model="search.publisher"
                                        @keyup="searchBooks">
                                </div>
                            </div>

                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.book.edition')}}</label>
                                      <v-select @input="searchBooks" label="name" :options="editions" v-model="search.edition">
                                    </v-select>

                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="detailedSearch">

                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.book.year')}}</label>
                                    <input type="text" v-model="search.year" @keyup="searchBooks" class="form-control">
                                </div>
                            </div>

                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.book.ISBN')}}</label>
                                    <input type="text" v-model="search.isbn" @keyup="searchBooks" class="form-control">
                                </div>
                            </div>

                            <div class="col-12">
                                <hr>
                            </div>

                            <div class="col-sm-6">
                                <div class="form-group">
                                    <input type="text" v-model="preset.name" class="form-control"
                                        :placeholder="$t('form.book.presetName')">
                                </div>
                            </div>

                            <div class="col-sm-6">
                                <button class="btn btn-primary" @click="savePreset">{{$t('button.save')}}</button>
                                <button class="btn btn-danger" v-show="presetSelected"
                                    @click="deletePreset">{{$t('button.delete')}}</button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- List -->
                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.book.bookList')}}</div>
                    </div>
                    <div class="card-body table-responsive p-0">
                        <table class="table table-hover" v-if="book_list.length">
                            <thead>
                                <tr class="header">
                                    <th>{{$t('form.book.title')}}</th>
                                    <th>{{$t('form.book.author')}}</th>
                                    <th>{{$t('form.book.publisher')}}</th>
                                    <th>{{$t('form.book.edition')}}</th>
                                    <th>{{$t('form.book.ISBN')}}</th>
                                    <th class="text-right fix-action">{{$t('form.book.action')}}</th>
                                </tr>
                            </thead>
                            <tbody v-for="(book, index) in book_list" v-bind:key="index">
                                <tr v-on:dblclick="goToEdit(book.ID)">
                                    <td>{{book.Title}}</td>
                                    <td>{{book.Author}}</td>
                                    <td>{{book.Publisher}}</td>
                                    <td>{{book.Edition}}</td>
                                    <td>{{book.ISBN}}</td>
                                    <td class="text-right">
                                        <button v-if="permissions.viewBooks" class="btn btn-info btn btn-sm"
                                            v-on:click="goToEdit(book.ID)"><span class="fa fa-edit"></span></button>
                                        <button v-if="permissions.deleteBooks" class="btn btn-danger btn btn-sm"
                                            v-on:click="deleteBook(index)"><span class="fa fa-trash"></span></button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                    </div>
                    <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                        @paginate="paginate()">
                    </pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        props: ['permissions'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',
                
                isLoading: false,
                fullPage: true,
                
                request_source: '',
                detailedSearch: false,
                presetSelected: false,
                
                pagination: {
                    current_page: 1
                },
                
                search: {},
                preset: {
                    name: '',
                    entity: 'book',
                    value: {}
                },

                presetList: [],
                editions:[],
                book_list: [],
                initialData: [],
            }
        },

        mounted() {
            this.isLoading = true;
            
            if (!this.permissions.viewBooks) {
                this.$router.push('/');
                return;
            }

            if (localStorage.getItem('filter-book')) {
                this.search = JSON.parse(localStorage.getItem('filter-book'));
            }

            this.getBooks();
            this.getPresets();
            this.getInitialData();
        },        
        
        watch: {
            search: {
                handler() {
                    localStorage.setItem('filter-book', JSON.stringify(this.search));
                },
                deep: true
            }
        },

        methods: {

            getBooks() {
                let source = axios.CancelToken.source();

                if (this.request_source != '')
                    this.request_source.cancel('Operation canceled by the user.');

                this.request_source = source;

                this.isLoading = true;
                axios
                    .get('/api/books?page=' + this.pagination.current_page, {
                        params: this.search,
                        cancelToken: this.request_source.token
                    })
                    .then(response => {
                        this.book_list = response.data.data.data;
                        this.pagination = response.data.pagination;
                        this.isLoading = false;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log(error.response);
                    });
            },

            // Get Initial Data
            getInitialData() {
                axios
                    .get('/api/books/initial-data')
                    .then(response => {
                        this.initialData = response.data;
                        this.editions = (response.data.books.filter(book => book.Edition)).map(ed => ed = ed.Edition).filter((x, i, a) => a.indexOf(x) == i);
                        
                    }, error => {
                        console.log(error.response);
                    });
            },

            paginate() {
                this.getBooks();
            },

            clearSearch() {
                this.search = {};
                this.searchBooks();
            },

            searchBooks() {
                this.pagination.current_page = 1;
                this.getBooks();
            },

           

            goToEdit(id) {
                if (! this.permissions.viewBooks) return;

                this.$router.push({
                    name: 'BookEdit',
                    params: {id: id}
                });
            },

            deleteBook(index) {
                let conf = confirm(this.$t('form.validation.delete'));
                if (conf === true) {
                    var id = this.book_list[index].ID;

                    this.isLoading = true;
                    axios
                        .delete('/api/books/' + id)
                        .then(response => {
                            this.isLoading = false;
                            this.book_list.splice(index, 1);
                            this.showAlert(response.data.message);
                        })
                        .catch(error => {
                            this.isLoading = false;
                            console.log(error);
                        });
                }
            },

            // Save a Preset with Unique Name
            savePreset() {
                this.isLoading = true;
                this.alert = false;

                this.preset.value = JSON.stringify(this.search);

                axios
                    .post('/api/presets', this.preset)
                    .then(response => {
                        this.isLoading = false;
                        this.showAlert(response.data.message);
                        this.getPresets();
                    }, error => {
                        this.isLoading = false;

                        if (error.response.status == 422) {
                            this.showAlert(error.response.data.errors.name[0], 'danger');
                        }
                    });
            },

            // Get Presets in Search Criteria
            getPresets() {
                axios
                    .get('/api/presets/?entity=' + this.preset.entity)
                    .then(response => {
                        this.presetList = response.data;
                    }, error => {
                        console.log(error.response);
                    });
            },

            // Get Search results according to selected Preset Name
            loadPreset() {
                if (!this.preset) {
                    this.search = {};
                    this.preset = {
                        entity: 'book'
                    };
                    this.alert = false;
                    this.presetSelected = false;
                    this.searchBooks();
                    return;
                }
                this.alert = false;
                this.presetSelected = true;
                this.search = JSON.parse(this.preset.value);
                this.searchBooks();
            },

            // Delete a selected Preset
            deletePreset() {
                let conf = confirm(this.$t('form.validation.delete'));

                if (conf === true) {
                    axios
                        .delete("/api/presets/" + this.preset.id)
                        .then(response => {
                            if (response.data.status == 'success') {
                                this.showAlert(response.data.message);
                                this.getPresets();
                                this.search = {};
                                this.searchBooks();
                                this.preset.name = '';
                                this.preset.value = {};
                                this.presetSelected = false;
                            }
                        })
                        .catch(error => {
                            this.isLoading = false;
                        });
                }
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        }
    }

</script>

<style scoped>

</style>
